import { useQuery } from '@tanstack/react-query';
import { permissionsClient } from 'api/MinSideClients';
import { PermissionResponse, PermissionSearchOrderBy, SortOrder } from 'api/minside';
import { SelectOption } from 'common.ui';

export function usePermissionsQuery(applicationIds?: string[]) {
  return useQuery({
    queryKey: ['permissions', applicationIds],
    enabled: applicationIds !== undefined,
    queryFn: async () => {
      const ids = applicationIds ?? [];
      if (ids.length === 0) return [];

      const results = await Promise.all(
        ids.map((id) =>
          permissionsClient.apiPermissionsGet({
            pageNumber: 1,
            pageSize: 9999,
            sortOrder: SortOrder.Ascending,
            orderField: PermissionSearchOrderBy.Name,
            applicationId: id
          })
        )
      );

      const allPermissions = results.flatMap((r) => r.data ?? []);
      const unique = Array.from(
        new Map(allPermissions.map((p: PermissionResponse) => [p.permissionId, p])).values()
      );

      return unique
        .sort((a: PermissionResponse, b: PermissionResponse) => (a.name ?? '').localeCompare(b.name ?? ''))
        .map((d: PermissionResponse) => ({ id: d.permissionId?.toString(), text: d.name }) as SelectOption);
    },
    staleTime: 5 * 60 * 1000
  });
}
